<div #topbar class="topbar clearfix" [style]="!showTopbarItems ? { backgroundColor: 'white' } : {}" rte="14C">
    <div *ngIf="showTopbarItems" class="topbar-left" routerLink="/" rte="14D">
        <lhs-mipro-logo />
    </div>

    <div class="topbar-right" rte="14F" [ngClass]="{ 'sm-screen': isSmallScreen }">
        <a *ngIf="showTopbarItems" id="menu-button" href="#" (click)="ultimaMain.onMenuButtonClick($event)" rte="14G">
            <i class="pi pi-angle-right" rte="14H"></i>
        </a>

        <div class="topbar-right-content">
            <ng-container *ngIf="app.patientSwitchAvailable">
                <patient-switch></patient-switch>
            </ng-container>
            <globaldro-terms></globaldro-terms>

            <current-organization-logo />

            <div class="right-side" rte="14I">
                <app-offline-indicator *ngIf="app.offlineIndicatorVisible" rte="14J"></app-offline-indicator>

                <a id="topbar-menu-button" href="#" (click)="ultimaMain.onTopbarMenuButtonClick($event)" rte="14K">
                    <i class="pi pi-bars" rte="14L"></i>
                </a>

                <ul class="topbar-items animated fadeInDown" [ngClass]="{ 'topbar-items-visible': ultimaMain.topbarMenuActive }" rte="14M">
                    @if (brandingService.currentOrganizationLogoUrl()) {
                        <li class="sm:hidden text-center px-2 py-1">
                            <img [src]="brandingService.currentOrganizationLogoUrl()" [ngStyle]="{
                                maxWidth: '100%',
                                maxHeight: '60px',
                                objectFit: 'contain'
                            }" />
                        </li>
                    }

                    <li
                        *ngIf="app.loadingTimeAvailable"
                        #loadingTimeTopbarItem
                        [ngClass]="{ 'active-top-menu': ultimaMain.activeTopbarItem === loadingTimeTopbarItem }"
                        title="Page Loading Time"
                        rte="15x">
                        <a
                            routerLink="/app/loading-time"
                            class="loading-time-button"
                            (click)="ultimaMain.onTopbarItemClick($event, loadingTimeTopbarItem)"
                            rte="15y">
                            <i class="topbar-icon material-icons" rte="15z">timelapse</i>
                            <span *ngIf="app.loadTime" class="topbar-badge animated rubberBand" rte="15A">{{ app.loadTime }}</span>
                            <span class="topbar-item-name" rte="15B">Loading Time</span>
                        </a>
                    </li>
                    <li
                        *ngIf="app.devToolsAvailable"
                        #showDevToolsTopbarItem
                        [ngClass]="{ 'active-top-menu': ultimaMain.activeTopbarItem === showDevToolsTopbarItem }"
                        title="Development Tools"
                        rte="15t">
                        <a
                            href="#"
                            class="development-tools-button"
                            (click)="app.showDevToolsDialog(); ultimaMain.onTopbarItemClick($event, showDevToolsTopbarItem)"
                            rte="15u">
                            <i class="topbar-icon material-icons" rte="15v">build</i>
                            <span class="topbar-item-name" rte="15w">Development Tools</span>
                        </a>
                    </li>

                    <li
                        *ngIf="app.feedbackAvailable"
                        #feedbackTopbarItem
                        [ngClass]="{ 'active-top-menu': ultimaMain.activeTopbarItem === feedbackTopbarItem }"
                        title="Feedback Tool"
                        rte="15n">
                        <a
                            href="#"
                            class="feedback-button"
                            (click)="app.showFeedback(); ultimaMain.onTopbarItemClick($event, feedbackTopbarItem)"
                            rte="15o">
                            <feedbacks-launcher
                                project-code="BC-BBWT3"
                                server-code="test"
                                attr.first-name="{{ app.feedbackUserFirstName }}"
                                attr.last-name="{{ app.feedbackUserLastName }}"
                                attr.email="{{ app.feedbackUserEmail }}"
                                style="display: none"
                                rte="15p">
                            </feedbacks-launcher>
                            <i class="topbar-icon pi pi-comment" rte="15q"></i>
                            <span class="topbar-item-name" rte="15s">Feedback</span>
                            <span *ngIf="app.feedbackService.counter" class="topbar-badge animated rubberBand" rte="15r">{{
                                app.feedbackService.counter
                            }}</span>
                        </a>
                    </li>
                    <li
                        *ngIf="app.runtimeEditorService.editorAllowedForUser"
                        #rutimeEditorTopbarItem
                        [ngClass]="{ 'active-top-menu': ultimaMain.activeTopbarItem === rutimeEditorTopbarItem }"
                        title="Runtime Editor"
                        rte="154">
                        <a
                            href="#"
                            class="runtime-editor-button"
                            (click)="onRuntimeEditorTopbarItemClick($event, rutimeEditorTopbarItem)"
                            rte="155">
                            <i class="topbar-icon mi mi-button-edit" rte="156"></i>
                            <span *ngIf="app.runtimeEditorUi.isEditorLoading" class="topbar-badge animated rubberBand" rte="157">
                                load...
                            </span>
                            <span *ngIf="app.runtimeEditorUi.isEditorOn" class="topbar-badge animated rubberBand" rte="158">
                                {{ app.runtimeEditorUi.newChangesCount }}/{{ app.runtimeEditorUi.changesCount }}
                            </span>
                            <span class="topbar-item-name" rte="159">Runtime Editor</span>
                        </a>

                        <ul class="ultima-menu animated fadeInDown" rte="15a">
                            <li role="menuitem" rte="15b">
                                <a href="#" (click)="app.runtimeEditorSave(); ultimaMain.onTopbarSubItemClick($event)" rte="15c">
                                    <i class="material-icons" rte="15d">send</i>
                                    <span rte="15e">Submit to PM</span>
                                </a>
                            </li>
                            <li role="menuitem" rte="15f">
                                <a href="#" (click)="app.runtimeEditorClose(); ultimaMain.onTopbarSubItemClick($event)" rte="15g">
                                    <i class="material-icons" rte="15h">close</i>
                                    <span rte="15i">Close Editor</span>
                                </a>
                            </li>
                            <li role="menuitem" rte="15j">
                                <a href="#" (click)="app.runtimeEditorCancel(); ultimaMain.onTopbarSubItemClick($event)" rte="15k">
                                    <i class="material-icons" rte="15l">cancel</i>
                                    <span rte="15m">Cancel New Changes</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li *ngIf="showTopbarItems && !app.isGenericPatient && !app.isGenericLogin">
                        <formio-inbox-indicator></formio-inbox-indicator>
                    </li>
                    <li *ngIf="showTopbarItems && !app.isClinicalSafetyOfficer">
                            <notification-indicator></notification-indicator>
                    </li>
                    <li title="Appointments" *ngIf="showTopbarItems && !app.isClinicalSafetyOfficer && !isPatient">
                        <a routerLink="/app/appointments">
                            <i class="topbar-icon mi mi-orb-appointments-no-col"></i>
                            <span class="topbar-item-name">Appointments</span>
                        </a>
                    </li>
                    <li>
                        <ultima-user-switch [appendTo]="topbar"></ultima-user-switch>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
